import { createApiClient, ApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';
import {history} from '../router';
import {MENTORS_URL} from '../router/urls';

export function setMentor(process_id: number, mentor: string){
  return (dispatch:any) =>{
    const api = createApiClient();
    api.setMentor(process_id, mentor, {
      success: async (response) => {
        dispatch({
          type: types.SET_MENTOR,
          payload: {
            process_id,
            mentor,
          }
        })
      }
    });
  }
}

export function getMentorProcessAll() {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mentor-process'});
    api.getMentorProcessAll({
      success: (response) => {
        dispatch({ type: types.FETCH_MENTOR_PROCESS, payload: response });
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'mentor-process' });
      }
    })
  }
}

export function getSpecialistProcessAll() {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mentor-process'});
    api.getSpecialistProcessAll({
      success: (response) => {
        dispatch({ type: types.FETCH_MENTOR_PROCESS, payload: response });
      },
      anyway: () => {
        dispatch({ type: types.LOADING_FINISH, payload: 'mentor-process' });
      }
    })
  }
}

export function acceptMentorProcess(process_id: string, accept: boolean, comment: string) {
  return (dispatch: any) => {
    const api = createApiClient();
    dispatch({type: types.LOADING_START, payload: 'mentor-process'});
    api.acceptMentorProcess(process_id,  accept, comment,{
      success: (response) => {
        dispatch({type: types.LOADING_FINISH, payload: 'mentor-process'});
        dispatch(getMentorProcessAll());
        history.push(MENTORS_URL);
      },
      error: (e, response) => {
        if( response ){
          const result = JSON.parse(response);
          if(result && result.message){
            alert(result.message);
          }else alert(`API ERROR: ${e}`);
        }else{
          alert(`API ERROR: ${e}`);
        }
        dispatch({type: types.LOADING_FINISH, payload: 'mentor-process'});
      }
    })
  }
}
